module.exports = __webpack_public_path__ + "static/media/icon-success.f7068e99.svg";